import { NgModule } from '@angular/core';
import { Store, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { featureKey, genesysCloudPresenceReducer } from './reducers/presence.reducers';
import { GenesysCloudPresenceEffects } from './effects/presence.effects';
import { initializeModule } from './actions/presence.actions';
import { BcConfigService } from 'common/config/provider';

@NgModule({
  imports: [
    StoreModule.forFeature(featureKey, genesysCloudPresenceReducer),
    EffectsModule.forFeature([
      GenesysCloudPresenceEffects
    ])
  ]
})
export class GenesysCloudPresenceModule {
  constructor(readonly store: Store, readonly configService: BcConfigService) {
    if (configService.isGenesysConversationEnabled()) {
      store.dispatch(initializeModule());
    }
  }
}
